import { FlexGrid, FlexGridItem } from "@mezo-org/mezo-clay"

import { STORE_ITEMS } from "#/shared/constants"

import MarketItem from "./MarketItem"
import MarketTahoNFTItem from "./MarketTahoNFTItem"

export default function StoreItemsList() {
  return (
    <FlexGrid
      flexGridColumnCount={[1, 1, 1, STORE_ITEMS.length]}
      flexGridColumnGap="scale300"
      flexGridRowGap="scale300"
    >
      {STORE_ITEMS.map((item) => (
        <FlexGridItem key={item.id}>
          <MarketItem
            id={item.id}
            name={item.name}
            description={item.description}
            price={item.price}
            image={item.image}
            fullImage={item.fullImage}
          />
        </FlexGridItem>
      ))}
      <FlexGridItem>
        <MarketTahoNFTItem />
      </FlexGridItem>
    </FlexGrid>
  )
}
